module.exports = __webpack_public_path__ + "img/red_icon2.de4223d9.png";